import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { useData } from '../DataHook';

export default function ({ show, onHide, itemName, unit, bag, box, selectedUnit, setSelectedUnit }) {
  const [amt, setAmt] = useState(0);
  const [fineAmt, setFineAmt] = useState(0);
  const { addCount } = useData();

  let amtText = "";
  let max = 5;
  let step = 1;

  let fine = false;
  let fineMax = 15 / 16;
  let fineStep = 0.0625;

  if (selectedUnit === 0) {
    const whole = Math.floor(amt)
    const oz = (fineAmt) * 16;
    amtText += `${amt} ${unit[1]} ${(oz / 100).toFixed(2).toString().substring(2)} oz (${(amt + fineAmt).toFixed(3)} ${unit[1]})`;
    max = 10;
    fine = true;
  } else if (selectedUnit === 1) {
    amtText = `${amt} bags (${amt * bag} ${unit[1]})`;
    max = 32;
  } else if (selectedUnit === 2) {
    amtText = amt + " "
    amtText = `${amt} boxes (${amt * bag * box} ${unit[1]})`;
    max = 20;
  }

  const hide = () => {
    setAmt(0);
    setFineAmt(0);
    onHide();
  }

  return <Modal show={show} onHide={hide}>
    <Modal.Header closeButton>
      <Modal.Title>Add {itemName}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div class="mb-3">
        <Form.Label>Amount: {amtText}</Form.Label>
        <Form.Control type="range" className="form-range" min="0" max={max} step={step} value={amt} onChange={e => setAmt(parseFloat(e.target.value))} />
        {fine ? <><hr /> <Form.Control type="range" className="form-range" min="0" max={fineMax} step={fineStep} value={fineAmt} onChange={e => setFineAmt(parseFloat(e.target.value))} /></> : null}
      </div>

      <Form.Check
        type="radio"
        label={unit[1]}
        name="unit"
        id={`custom - add - unit1 - ${itemName} `}
        inline
        checked={selectedUnit === 0}
        onClick={() => { setSelectedUnit(0); setAmt(0) }}
      />
      <Form.Check
        type="radio"
        label="Bags"
        name="unit"
        id={`custom - add - unit2 - ${itemName} `}
        inline
        checked={selectedUnit === 1}
        onClick={() => { setSelectedUnit(1); setAmt(0) }}
      />
      <Form.Check
        type="radio"
        label="Boxes"
        name="unit"
        id={`custom - add - unit3 - ${itemName} `}
        inline
        checked={selectedUnit === 2}
        onClick={() => { setSelectedUnit(2); setAmt(0) }}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={hide}>Close</Button>
      <Button onClick={() => {
        let amount = amt + fineAmt;
        if (selectedUnit > 0) amount *= bag;
        if (selectedUnit > 1) amount *= box;
        addCount(itemName, amount);
        setSelectedUnit(selectedUnit === 0 ? 0 : selectedUnit - 1);
        hide();
      }}>Change</Button>
    </Modal.Footer>
  </Modal>;
}